import React from 'react'
import Header from './Header'
import VideoGallery from './VideoGallery'

function OurBlogs() {
  return (
    <div className=' '>

<div className="relative">
  <img className='object-cover w-full h-[1000px]' src='images/mosque5.jpg' alt="Library" />
  <div className='absolute inset-0 flex flex-col justify-center items-center text-center bg-black bg-opacity-50'>
    <h1 className='text-5xl text-white'>وَالَّذِينَ جَاهَدُوا فِينَا لَنَهْدِيَنَّهُمْ سُبُلَنَا</h1>
    <p className='text-xl text-white p-6'>"And those who strive for Us, We will surely guide them to Our ways..."   Surah Al-Ankabut (29:69) </p>
  </div>
</div>



<div className=' p-40'>
<VideoGallery/>
  
  </div>    </div>
  )
}

export default OurBlogs